<template>
    <div class="app-video-box">
        <!--<span v-show="is_mute">123</span>-->
        <video ref="video" :muted="is_mute" id="video" class="app-video" autoplay="autoplay" loop="loop" src="//video-output.vhiphop.top/web/app.mp4"></video>
        <div class="app-video-voice" @click="is_mute = !is_mute">
            <i :class="is_mute ? 'icon-mute' : 'icon-voice'"></i>
        </div>

        <!--<div class="app-video-voice" @click="switchMute">
            <i :class="is_mute ? 'icon-mute' : 'icon-voice'"></i>
        </div>-->
    </div>
</template>

<script>
    export default {
        data: () => ({
            is_mute: true,
        }),
        /*methods: {
            switchMute() {
                this.is_mute = !this.is_mute;// 切换状态

                console.log(this.$refs['video'].muted);// 每次打印都是true

                document.querySelector('#video').muted = this.is_mute;

                console.log(this.$refs['video'].muted);// 正常切换状态
            }
        }*/
        beforeCreate() {
            let vd = document.getElementById('app-css'), style = `
#app #header {
    background-color: transparent;
    box-shadow: none;
}

#app #footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    border-top-color: transparent;
    background-color: transparent;
}`;
            if (vd) {
                vd.innerHTML = style;
            } else {
                vd = document.createElement('style');
                vd.id = 'app-css';
                vd.innerHTML = style;
                document.head.appendChild(vd);
            }
        },
        mounted() {
            this.$refs.video.volume = 0.07;
        },
        beforeDestroy() {
            document.getElementById('app-css').innerHTML = '';
        }
    }
</script>

<style scoped>
    @import "../../../static/css/common/app.css";
</style>


// WEBPACK FOOTER //
// src/views/app/Detail.vue